import { transparentize } from 'polished';
import { Color } from '../../constants/ColorEnum';
export const BoxShadow = {
    S: `0px 2px 8px ${transparentize(0.95, Color.BLACK_MAMBA)}`,
    M: `0px 4px 20px ${transparentize(0.95, Color.BLACK_MAMBA)}`,
    L: `0px 12px 32px ${transparentize(0.95, Color.BLACK_MAMBA)}`,
};

export default BoxShadow;
